import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [activeDog, setActiveDog] = useState(null);
  const [mode, setMode] = useState('owner'); // 'owner' or 'admin'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load user from localStorage on mount
    const savedUser = localStorage.getItem('edupaws_user');
    const savedDog = localStorage.getItem('edupaws_active_dog');
    const savedMode = localStorage.getItem('edupaws_mode');
    
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    if (savedDog) {
      setActiveDog(JSON.parse(savedDog));
    }
    if (savedMode) {
      setMode(savedMode);
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('edupaws_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setActiveDog(null);
    localStorage.removeItem('edupaws_user');
    localStorage.removeItem('edupaws_active_dog');
  };

  const switchMode = (newMode) => {
    setMode(newMode);
    localStorage.setItem('edupaws_mode', newMode);
    // Logout when switching modes
    logout();
  };

  const selectDog = (dog) => {
    setActiveDog(dog);
    localStorage.setItem('edupaws_active_dog', JSON.stringify(dog));
  };

  return (
    <AuthContext.Provider value={{
      user,
      activeDog,
      mode,
      loading,
      login,
      logout,
      switchMode,
      selectDog,
      isAuthenticated: !!user,
      isOwner: mode === 'owner' && !!user,
      isAdmin: mode === 'admin' && !!user
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
